import React, { Fragment } from 'react';
import { withTranslation, Trans } from 'react-i18next';
import {
    Col, Row, Button, Form, FormGroup, Input, Label
} from 'reactstrap';
import { toast } from 'react-toastify';
import ReCAPTCHA from 'react-google-recaptcha';
import { Link } from 'react-router-dom';
import { AuthContext } from 'context/AuthContext';
import UserLoginAPI from 'API/UserLoginAPI';

class Register extends React.Component {

    static contextType = AuthContext;

    constructor(props) {
        super(props);

        this.state = {
            name: "",
            email: "",
            password: "",
            phonenumber: "",
            company: "",
            captcha: null,
            submitting: false,
            registered: false,
            // agree: true
        };

        this.captchaRef = React.createRef();

        this.handleChange = this.handleChange.bind(this);
        this.handleCaptcha = this.handleCaptcha.bind(this);
        this.goBack = this.goBack.bind(this);
        this.doRegister = this.doRegister.bind(this);
    }

    handleChange(event) {
        const key = event.target.name;
        const value = event.target.type === 'checkbox'
            ? event.target.checked : event.target.value;
        this.setState({
            [key]: value
        });
    }

    handleCaptcha(value) {
        this.setState({captcha: value});
    }

    goBack() {
        let history = this.props.history;
        history.push('/');
        this.context.doLogout(); // clear context
    }

    resetCaptcha() {
        // a captcha token can only be used once
        if (this.captchaRef.current) {
            this.captchaRef.current.reset();
        }
        this.setState({ captcha: null });
    }

    doRegister() {
        const { name, email, password, phonenumber, company, captcha, submitting } = this.state;
        if (submitting) {
            return; // avoid creating the account more than once
        }
        if (captcha && name && email && password && company && phonenumber) {
            this.setState({ submitting: true });
            UserLoginAPI.createUser(name, email.trim().toLowerCase(), password, company, phonenumber).then(result => {
                if (!result || ((result.cod || result.code) && !String(result.cod || result.code).startsWith('2'))) {
                    throw new Error(result && (result.message || result.data));
                }
                this.setState({ submitting: false, registered: true });
            }).catch(error => {
                console.error("Error on register", error);
                toast["error"]((error && error.message) || this.props.t('register.error'));
                this.setState({ submitting: false });
                this.resetCaptcha();
            });
        } else {
            if (!name || !email || !password || !phonenumber || !company) {
                toast["warning"](this.props.t('messages.fill_all_fields'));
            // }else if (!agree) {
            //     toast["warning"](this.props.t('register.agree_message'));
            } else if (!captcha) {
                toast["warning"](this.props.t('register.captcha_message'));
            }
        }
    }

    render() {
        const { t, i18n } = this.props;

        const { submitting, registered } = this.state;
        const disabled = !this.state.captcha || submitting;

        return (
            <Fragment>
                <main className={"bg-white signup" + (submitting ? " is-submitting" : "")}>
                    <div className="row g-0 min-vh-100">
                        <div className="col-lg-6 col-md-6 col-sm-12 signup-side">
                            <div className="signup-form">
                                <div className="text-center">
                                    <a href="/"><img src="/imgs/logo.png" alt="EmailVeritas" className="signup-logo" /></a>
                                    <p className="signup-text">{t("register.text")}</p>
                                </div>
                                {registered ? (
                                    <div className="signup-success">
                                        <div className="signup-success-icon">&#10003;</div>
                                        <h4>{t('register.success_title')}</h4>
                                        <p>{t('register.success')}</p>
                                        <p className="signup-success-email">{this.state.email}</p>
                                        <Link to="/auth/login" className="signup-success-login" onClick={this.context.loginEmailPassword}>
                                            {t('register.actions.login')}
                                        </Link>
                                    </div>
                                ) : (
                                    <Fragment>
                                        <Form onSubmit={(e) => { e.preventDefault(); }} autoComplete="off">
                                            <fieldset>
                                                <Input type="text" name="name" id="name"
                                                    placeholder={t('register.name')} maxLength="50"
                                                    value={this.state.name} onChange={this.handleChange} />
                                            </fieldset>
                                            <fieldset>
                                                <Input type="email" name="email" id="email"
                                                    placeholder={t('register.email')} maxLength="100"
                                                    value={this.state.email} onChange={this.handleChange} />
                                            </fieldset>
                                            <fieldset>
                                                <Input type="text" name="company" id="company"
                                                    placeholder={t('register.company')} maxLength="50"
                                                    value={this.state.company} onChange={this.handleChange} />
                                            </fieldset>
                                            <fieldset>
                                                <Input type="password" name="password" id="password"
                                                    placeholder={t('register.password')} maxLength="50"
                                                    value={this.state.password} onChange={this.handleChange} />
                                            </fieldset>
                                            <fieldset>
                                                <Input type="tel" name="phonenumber" id="phonenumber"
                                                    placeholder={t('register.phonenumber')} maxLength="50"
                                                    value={this.state.phonenumber} onChange={this.handleChange} />
                                            </fieldset>
                                            <p className="signup-agreement">
                                                <Trans i18nKey="register.agreement">
                                                    By signing up, I accept the
                                                    <a href="https://www.emailveritas.com/terms-service" target="_blank">Terms of Service</a>
                                                    <a href="https://www.emailveritas.com/privacy-policy" target="_blank">Privacy Policy</a>
                                                </Trans>
                                            </p>
                                            <div className="d-flex justify-content-center my-3">
                                                <ReCAPTCHA ref={this.captchaRef} sitekey={this.context.siteKey} onChange={this.handleCaptcha} />
                                            </div>
                                            <Input type='submit' color="primary" size="lg"
                                                onClick={this.doRegister} disabled={disabled}
                                                value={submitting ? t("register.actions.creating") : t("register.actions.create")} />
                                        </Form>

                                        <p className="signup-or">{t('register.or')}</p>

                                        <a href="#" className="signup-social" onClick={this.context.loginMicrosoft}>
                                            <img src="/imgs/microsoft.png" alt="" />
                                            {t("register.actions.login_microsoft")}
                                        </a>
                                        <a href="#" className="signup-social" onClick={this.context.loginGoogle}>
                                            <img src="/imgs/google.png" alt="" />
                                            {t("register.actions.login_google")}
                                        </a>
                                    </Fragment>
                                )}

                                {!registered && (
                                    <p className="text-center mt-4">
                                        {t('register.have_account')} <Link to="/auth/login" className="link-account" onClick={this.context.loginEmailPassword}>{t('register.actions.login')}</Link>
                                    </p>
                                )}
                            </div>
                        </div>

                        <div className="col-lg-6 col-md-6 d-none d-md-flex align-items-center bg-default">
                            <section className="signup-why">
                                <h3 data-aos="fade-up">Protect yourself and your company against:</h3>
                                <div className="d-flex align-items-center icon-box" data-aos="fade-up">
                                    <div className="icon me-3"><img src="/imgs/icons/interruption-verde-sec.png" alt="" className="img-icon" /></div>
                                    <h4 className="title">Business interruption</h4>
                                </div>
                                <div className="d-flex align-items-center icon-box" data-aos="fade-up">
                                    <div className="icon me-3"><img src="/imgs/icons/chart-down-verde-sec.png" alt="" className="img-icon" /></div>
                                    <h4 className="title">Financial Losses</h4>
                                </div>
                                <div className="d-flex align-items-center icon-box" data-aos="fade-up">
                                    <div className="icon me-3"><img src="/imgs/icons/bad-reputation-verde-sec.png" alt="" className="img-icon" /></div>
                                    <h4 className="title">Brand reputation cost</h4>
                                </div>
                                <div className="d-flex align-items-center icon-box" data-aos="fade-up">
                                    <div className="icon me-3"><img src="/imgs/icons/data-loss-verde-sec.png" alt="" className="img-icon" /></div>
                                    <h4 className="title">Data Loss</h4>
                                </div>
                                <div className="d-flex align-items-center icon-box" data-aos="fade-up">
                                    <div className="icon me-3"><img src="/imgs/icons/leaking-verde-sec.png" alt="" className="img-icon" /></div>
                                    <h4 className="title">Leaking confidential information</h4>
                                </div>
                                <div className="d-flex align-items-center icon-box" data-aos="fade-up">
                                    <div className="icon me-3"><img src="/imgs/icons/law-book-verde-sec.png" alt="" className="img-icon" /></div>
                                    <h4 className="title">GDPR compliance</h4>
                                </div>
                            </section>
                        </div>
                    </div>
                </main>
            </Fragment>
        )
    }
};

export default withTranslation()(Register);